import { cellToLatLng } from "h3-js";

import type { CoordsType, H3IndexType } from "~/lib/map/types";

const getAverage = (amount: number, count: number, digits: number = 5): number => {
  const digitsNum = 10 ** digits;

  return Math.round((amount * digitsNum) / count) / digitsNum;
};

type CheckLongTotalType = [
  // east lng
  {
    total: 0;
    count: 0;
  },
  // west lng
  {
    total: 0;
    count: 0;
  },
];

const checkLongDistanceReverse = (h3Indexes: H3IndexType[]): boolean => {
  const initialData: CheckLongTotalType = [
    {
      total: 0,
      count: 0,
    },
    {
      total: 0,
      count: 0,
    },
  ];

  const [eastLng, westLng] = h3Indexes.reduce((data, h3index) => {
    const [, lng] = cellToLatLng(h3index);
    const selectedIndex = lng >= 0 ? 0 : 1;
    const { total, count } = data[selectedIndex];

    return [
      ...data.slice(0, selectedIndex),
      {
        total: total + lng,
        count: count + 1,
      },
      ...data.slice(selectedIndex + 1),
    ] as typeof initialData;
  }, initialData);

  if ([eastLng, westLng].some(({ count }) => count === 0)) {
    return false;
  }

  const eastLngAverage = getAverage(eastLng.total, eastLng.count);
  const westLngAverage = getAverage(westLng.total, westLng.count);
  const distance = eastLngAverage - westLngAverage;

  // 東経と西経の距離が 180度を超える場合は逆回りの方が近い
  return distance > 180;
};

export const getCenterCoordsFromH3Indexes = (h3indexes: H3IndexType[]): CoordsType => {
  const count = h3indexes.length;
  const isLngReverse = checkLongDistanceReverse(h3indexes);

  const { totalLat, totalLng } = h3indexes.reduce(
    // eslint-disable-next-line no-shadow
    ({ totalLat, totalLng }, h3index) => {
      const [lat, lng] = cellToLatLng(h3index);

      if (isLngReverse) {
        return {
          totalLat: totalLat + lat,
          totalLng: totalLng + (lng > 0 ? lng : lng + 360),
        };
      }

      return {
        totalLat: totalLat + lat,
        totalLng: totalLng + lng,
      };
    },
    {
      totalLat: 0,
      totalLng: 0,
    },
  );

  return {
    lat: getAverage(totalLat, count),
    lng: getAverage(totalLng, count),
  };
};
